import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Progress from '@radix-ui/react-progress';

import StepImg from 'components/Step';
import Input from 'components/form/Input';
import Navbar from 'components/layouts/Navbar';
import TutorialDialog from 'components/dialog/TutorialDialog';

import PressBtn from 'assets/images/press_btn.png';
import ChatBubble from 'assets/images/chat_bubble.png';
import CoinIcon from 'assets/images/coin_icon.png';
import MenuIcon from 'assets/images/menu_icon.svg';
import TutorialCheck from 'assets/images/tutorial_check.png';

export default function Tutorial() {
  // hooks
  const navigate = useNavigate();

  // state
  const [step, setStep] = useState(1);

  // method
  const handleStep = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    if (step === 4) {
      // todo 메인화면 이동 전 데이터 호출 후 저장
      navigate('/play');
    } else {
      setStep((prev) => (prev += 1));
    }
  };

  return (
    <>
      <div
        className={`relative mx-auto flex h-full max-w-[1024px] flex-col bg-[url(assets/images/play_background.png)] bg-contain`}
      >
        <header
          className={`border-b-3 absolute top-0 z-50 flex h-[64px] w-full items-center justify-between border-[#7F7F7F] bg-[url(assets/images/background.png)] bg-cover pl-[24px] pr-[30px]`}
        >
          <div className="relative flex">
            <img className="absolute -left-[8px] -top-[2px] h-[35px] w-[30px]" src={CoinIcon} />
            <Input
              className="h-[27px] w-[111px] pr-[9px] text-right text-[16px] font-[800] text-[#FF5019]"
              readOnly
              value={step !== 1 ? '100P' : '0P'}
            />
          </div>

          <button>
            <img className="h-[32px] w-[30px]" src={MenuIcon} />
          </button>
        </header>
        <main className={`h-[calc(100dvh-160px)] flex-1 pb-[96px] pt-[64px]`}>
          <div className="flex h-full flex-col items-center overflow-auto">
            <div className="w-full px-[18px] py-[20px]">
              <div className="mb-[9px] flex justify-between">
                <span className="text-[11px] text-[#FF4F19]">0P</span>
                <span className="text-[11px] text-[#FF4F19]">100P</span>
              </div>

              <Progress.Root
                className="relative h-[22px] w-full overflow-hidden rounded-full border-b-2 border-[#9CAAAE] bg-[#35160D]"
                style={{
                  transform: 'translateZ(0)',
                }}
                max={100000}
                value={step === 1 ? 0 : 100}
              >
                <div className="border-3 size-full overflow-hidden rounded-full border-[#6C2D1A]">
                  <Progress.Indicator
                    className="ease-[cubic-bezier(0.65, 0, 0.35, 1)] size-full bg-white transition-all duration-[660ms]"
                    style={{
                      width: step === 1 ? '0%' : '100%',
                      backgroundImage: 'linear-gradient(to bottom, #FFEEC4, #FF3D00)',
                    }}
                  />
                </div>
              </Progress.Root>

              <p className="mt-[10px] text-center text-[13px] font-bold text-[#6B2D19]">
                Collect 1,00P to purchase land!
              </p>
            </div>

            <div className="relative my-auto w-full px-[55px]">
              <StepImg step={0} />
            </div>

            <div className="mt-auto text-center">
              <button className="mb-[30px]">
                <img src={PressBtn} className="h-[94px] w-[96px]" />
              </button>
            </div>
          </div>

          {step === 3 && <TutorialDialog />}
        </main>

        <Navbar />
      </div>

      <div onClick={handleStep} className="z-60 fixed inset-0 mx-auto max-w-[1024px] bg-black/60">
        {step === 1 && (
          <div onClick={handleStep}>
            <div className="fixed bottom-1/2 left-1/2 z-[70] flex w-full -translate-x-1/2 justify-center gap-[12px]">
              <img className="h-[24px] w-[24px]" src={TutorialCheck} />
              <div className="text-[12px] font-semibold tracking-[0.02em] text-white">
                <span className="text-[16px] font-black leading-[20px] -tracking-[0.02]">
                  Go ahead,
                  <br />
                  tap the button to mine some points!
                </span>
              </div>
            </div>

            <button className="fixed bottom-[130px] left-1/2 z-[70] -translate-x-1/2">
              <img src={PressBtn} className="h-[94px] w-[96px]" />
            </button>
          </div>
        )}

        {step === 2 && (
          <div onClick={handleStep}>
            <div className="fixed bottom-1/2 left-1/2 z-[70] flex w-full -translate-x-1/2 justify-center gap-[12px]">
              <img className="h-[24px] w-[24px]" src={TutorialCheck} />
              <div className="text-[12px] font-semibold tracking-[0.02em] text-white">
                <span className="text-[16px] font-black leading-[20px] -tracking-[0.02]">
                  You can come back and mine once
                  <br /> every 24 hours — don’t miss it!
                </span>
              </div>
            </div>
            <div className="absolute left-[24px] top-[16px] z-[70] flex">
              <img className="absolute -left-[8px] -top-[2px] h-[35px] w-[30px]" src={CoinIcon} />
              <Input
                className="h-[27px] w-[111px] pr-[9px] text-right text-[16px] text-[#FF5019]"
                readOnly
                value={'100P'}
              />
            </div>
            <div className="fixed bottom-[224px] left-1/2 z-[80] -translate-x-1/2">
              <img src={ChatBubble} className="top-[10px] h-[55px] w-[163px] translate-y-[10px]" />
              <div className="absolute left-0 top-[18px] flex w-full flex-col gap-[6px] text-center">
                <span className="h-[7px] text-[10px]">Get the next point!</span>
                <span className="h-[5px] text-[7px]">23H 17M</span>
              </div>
            </div>

            <button className="fixed bottom-[130px] left-1/2 z-[70] -translate-x-1/2">
              <img src={PressBtn} className="h-[94px] w-[96px]" />
            </button>
          </div>
        )}

        {step === 3 && (
          <div
            onClick={handleStep}
            className="fixed bottom-1/2 left-1/2 z-[100] flex w-full -translate-x-1/2 justify-center gap-[12px]"
          >
            <img className="h-[24px] w-[24px]" src={TutorialCheck} />
            <div className="text-[12px] font-semibold tracking-[0.02em] text-white">
              <span className="text-[16px] font-black leading-[20px] -tracking-[0.02]">
                Congrats! You’ve just bought
                <br /> some land!
                <br />
                Complete missions to hit your
                <br /> goals and earn extra points!
              </span>
            </div>
          </div>
        )}

        {step === 4 && (
          <div
            onClick={handleStep}
            className="fixed bottom-1/2 left-1/2 z-[70] flex w-full -translate-x-1/2 justify-center gap-[12px]"
          >
            <img className="h-[24px] w-[24px]" src={TutorialCheck} />
            <div className="text-[12px] font-semibold tracking-[0.02em] text-white">
              <span className="text-[16px] font-black leading-[20px] -tracking-[0.02]">
                Now use your points to rent
                <br /> buildings and check out your
                <br />
                monthly rewards!
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
